export default __webpack_public_path__ + "static/media/gliForm_logoNew.ae8ad560.png";